import '../App.css';
import { useEffect, useState } from 'react';
import { useSearchParams } from "react-router-dom";
import { ethers } from 'ethers';
import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { Box, Grid, Button, Input, Alert, AlertTitle } from '@mui/material';
import Dialog from '@mui/material/Dialog';

import { useNavigate } from 'react-router-dom';
import CopyClipboard from '../assets/copy_clipboard.png';
import Checked from '../assets/checked.png';
import Close from '../assets/close.png';


function GetWlSpot() {
    const navigate = useNavigate();
    const [width, setWindowWidth] = useState(0);
    const [height, setWindowHeight] = useState(0);

    const [isUserName, setIsUserName] = useState(true);
    const [userName, setUserName] = useState('');

    const [isWalletConnected, setIsWalletConnected] = useState(false);
    const [haveMetamask, setHaveMetamask] = useState(true);
    const [accountAddress, setAccountAddress] = useState('');
    const [accountBalance, setAccountBalance] = useState('');

    const [isOpenTweet, setIsOpenTweet] = useState(false);
    const [isSubmission, setIsSubmission] = useState(false);

    const [searchParams] = useSearchParams();

    const { ethereum } = window;

    const firebaseConfig = {
        apiKey: "AIzaSyBzin0945Ik2p_peI0ePWxQmmbgCwekcAM",
        authDomain: "raonwars.firebaseapp.com",
        projectId: "raonwars",
        storageBucket: "raonwars.appspot.com",
        messagingSenderId: "1043437610885",
        appId: "1:1043437610885:web:3bc2c7ba2b5ebb242006ec",
        measurementId: "G-GWGFZQKBM6"
    };

    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const db = getFirestore(app);

    useEffect(() => {
        updateDimensions();
        window.addEventListener("resize", updateDimensions);

        const { ethereum } = window;
        const checkMetamaskAvailability = async () => {
            if (!ethereum) {
                setHaveMetamask(false);
            }
            setHaveMetamask(true);
        };

        checkMetamaskAvailability();

        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, []);

    const updateDimensions = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        setWindowWidth(width);
        setWindowHeight(height);
    }

    const isMobile = () => {
        return width < 1440;
    }

    const isOverFlow = () => {
        return height < 1440;
    }

    const userNameInputDone = (event) => {
        if (event.target.value !== "") {
            setUserName(event.target.value);
            setIsUserName(true);
        } else {
            setIsUserName(false);
        }
    }

    const addDataToFirebase = async () => {
        try {
            const docRef = await addDoc(collection(db, "whitelist-exclusive-nft"), {
                wallet: accountAddress,
            });
            console.log("Document written with ID: ", docRef.id);
        } catch (e) {
            console.error("Error adding document: ", e);
        }
    }

    const walletAddressInputDone = (event) => {
        if (event.target.value !== "") {
            setAccountAddress(event.target.value);
            setIsWalletConnected(true);
        } else {
            setIsWalletConnected(false);
        }
    }

    const connectWallet = async () => {
        try {
            if (!ethereum) {
                setHaveMetamask(false);
                return;
            }

            const accounts = await ethereum.request({
                method: 'eth_requestAccounts',
            });

            const provider = new ethers.providers.Web3Provider(window.ethereum);
            let balance = await provider.getBalance(accounts[0]);
            let bal = ethers.utils.formatEther(balance);

            setAccountAddress(accounts[0]);
            setAccountBalance(bal);
            setIsWalletConnected(true);
        } catch (error) {
            setIsWalletConnected(false);
        }
    };

    const openTweetPrompt = () => {
        window.open('https://twitter.com/intent/tweet?text=I%27M%20COMING%20TO%20TAKE%20YOUR%20$RAON%20NERDS!!%0a%0aGoTo:%20raonwars.web.app/wlspot%0a%0a@Raonwars', "_blank", "noreferrer");
        setIsOpenTweet(true);
    };

    const submission = () => {
        if (isUserName && isWalletConnected && isOpenTweet) {
            addDataToFirebase().then(() => {
                setIsSubmission(true);
            });
        }
    }

    const handleClose = () => {
        setIsSubmission(false);
    };

    return (
        <div className='get-wlspot'>
            <Grid item>
                {!haveMetamask && <Alert severity="info" onClose={() => { setHaveMetamask(true) }} style={{ margin: "20px" }}>
                    <AlertTitle>Information</AlertTitle>
                    MetaMask is not detected. Please make sure you have MetaMask installed and enabled in your browser.
                </Alert>}
                <Dialog
                    fullScreen
                    open={isSubmission}
                    onClose={handleClose}
                    PaperProps={{
                        style: {
                            backgroundColor: 'rgb(223, 163, 99)',
                            opacity: 0.9
                        },
                    }}
                >
                    <Grid
                        container
                        style={{ height: '100vh', justifyContent: "center" }}
                        alignItems="center"
                        justify="center"
                    >
                        <Box textAlign="center">
                            <Grid item>
                                <div className='title-logo-mobile'>Congrats!</div>
                            </Grid>
                            <Grid item>
                                <p className='game-text'>Your wallet is now whitelisted for presale access.<br /><a href='https://raonwars.web.app/'>click here</a> to find out when presale begins & check<br />your status!</p>
                            </Grid>
                            <Grid item>
                                <p className='game-text'>See you soon!</p>
                            </Grid>
                        </Box>
                    </Grid>
                    <div class="close-dialog">
                        <Button onClick={handleClose}>
                            <img src={Close} alt='close'></img>
                        </Button>
                    </div>
                </Dialog>
                <Box textAlign="center">
                    <Grid item>
                        {/* <img src={CreateAccount} width={isMobile() ? "100%" : "40%"} style={{ marginBottom: "40px" }} alt='create account' /> */}
                        <div className='title-logo-mobile' style={{ paddingTop: "120px" }}>Welcome to Raonwars</div>
                        <div className='body-text-mobile' style={{ paddingBottom: "40px" }}>Mark your calendar for our highly anticipated launch on August 4, 2023.<br></br>We are thrilled to announce that our RAON token will be live soon.
                            <br></br>Get ready for a phenomenal launch experience and an opportunity to own your unique Raonwars.<br></br>Please register to Whitelist now!</div>
                    </Grid>
                    {/* <Grid container spacing={1} alignItems="center" justifyContent={"center"}>
                        <Grid item>
                            <Box className="check_box" bgcolor={isUserName ? "#FFD700" : 0}>
                                {isUserName && <img src={Checked} alt="input_user_checked" width={"40px"} />}
                            </Box>
                        </Grid>
                        <Grid item>
                            <Input disableUnderline={true} placeholder="YOUR NAME" className='input' inputProps={{ style: { textAlign: 'center' } }} onBlur={userNameInputDone} onChange={() => {
                                setIsUserName(false);
                            }} />
                        </Grid>
                    </Grid> */}
                    <Grid container spacing={1} alignItems="center" justifyContent={"center"}>
                        <Grid item>
                            <Box className="check_box" bgcolor={isWalletConnected ? "#FFD700" : 0}>
                                {isWalletConnected && <img src={Checked} alt="input_user_checked" width={"40px"} />}
                            </Box>
                        </Grid>
                        <Grid item>
                            {/* <Button variant="contained" onClick={connectWallet} className='checkbox-button'>
                                {isWalletConnected ? "WALLET CONNECTED" : "CONNECT WALLET"}
                            </Button> */}
                            <Input disableUnderline={true} placeholder="ETH WALLET ADDRESS" className='input' inputProps={{ style: { textAlign: 'center' } }} onBlur={walletAddressInputDone} onChange={() => {
                                setIsWalletConnected(false);
                            }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} alignItems="center" justifyContent={"center"}>
                        <Grid item>
                            <Box className="check_box" bgcolor={isOpenTweet ? "#FFD700" : 0}>
                                {isOpenTweet && <img src={Checked} alt="input_user_checked" width={"40px"} />}
                            </Box>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" onClick={openTweetPrompt} className='checkbox-button'>
                                LET 'EM KNOW
                            </Button>
                        </Grid>
                    </Grid>
                    {isWalletConnected && <Grid item>
                        <Grid container spacing={1} alignItems="center" justifyContent={"center"}>
                            <Grid item>
                                <p className='game-text'>{accountAddress.slice(0, 5) + "..." + accountAddress.slice(accountAddress.length - 4)}</p>
                            </Grid>
                            <Grid item>
                                <p className='game-text'><Button className='copy-button' onClick={() => { navigator.clipboard.writeText(accountAddress) }}><img src={CopyClipboard} alt="Copy Clipboard" width={24}></img></Button></p>
                            </Grid>
                        </Grid>
                    </Grid>}
                    <Grid item>
                        <Button variant="contained" onClick={submission} className='play-button' style={{ marginTop: !isWalletConnected && "80px", marginBottom: "80px" }}>
                            Submit
                        </Button>
                    </Grid>
                </Box>
            </Grid>

        </div>
    );
}

export default GetWlSpot;
